export const actionChangeDataFavoritePage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_FAVORITE', name, value
});

export const actionAddToFavoriteList = (slug) => ({
    type: 'ACTION_ADD_TO_FAVORITE_LIST', slug
});

export const actionRemoveFromFavoriteList = (slug) => ({
    type: 'ACTION_REMOVE_FROM_FAVORITE_LIST', slug
});

export const actionRemoveAllItemFromFavoriteList = () => ({
    type: 'ACTION_REMOVE_ALL_ITEM_IN_FAVORITE_LIST'
});
